export const routes = {
  dashboard: "/",
  login: "/login",
  download: "/reports/:id",
  admin: "/admin",
  adminNewPraxis: "/admin/praxes/new",
  adminPraxis: "/admin/praxes/:subdomain",
} as const;

export const adminPraxisRoute = (subdomain: string) =>
  routes.adminPraxis.replace(":subdomain", encodeURIComponent(subdomain));
